import Request from '@/Types/request';
import apiClient from '@/Services/Clients/apiClient';

const REQUEST_BASE_URL = 'api/request';

export default class RequestService {

  public static getRequest(requestId: string): Promise<Request> {

    const resourceUrl = `${REQUEST_BASE_URL}/${requestId}`;
    return apiClient.get(resourceUrl);
  }

  /**
   * @param {object} requestDataModel
   * @return {Promise}
   */
  public static updateRequest(requestDataModel) {

    const resourceUrl = `${REQUEST_BASE_URL}/${requestDataModel.requestId}?submitResponse=false`;
    return apiClient.put(resourceUrl, requestDataModel);
  }

  /**
   * @param {object} requestDataModel
   * @return {Promise}
   */
  public static updateRequestAndSubmitResponse(requestDataModel) {
    const resourceUrl = `${REQUEST_BASE_URL}/${requestDataModel.requestId}?submitResponse=true`;
    return apiClient.put(resourceUrl, requestDataModel);
  }

  /**
   * @param {string} requestId
   * @return {Promise}
   */
  public static requestHasUploadMetadata(requestId: string) {
    const resourceUrl = `${REQUEST_BASE_URL}/${requestId}/hasuploadmetadata`;
    return apiClient.get(resourceUrl);
  }
}
